import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import { addComment, getPostComment, replyComment } from "../../api/wall";
import "./InsComments.scss";
import {
  addArticleComment,
  getArticleComments,
  replyArticleComment,
} from "../../api/news";
import images from "../../ressources/images";
import {
  addCourseComment,
  getCourseComments,
  replyCourseComment,
} from "../../api/training";
import { XHRImage as Image } from "../Media/Image";

class InsComments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comments: [],
      comment: "",
      showComments: false,
      reply: false,
      countRepliedComments: 0,
      contentHeight: window.innerHeight,
    };

    this.contentId = this.props.contentId;
  }

  componentDidMount() {
    this.getAllComments();
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  getAllComments = () => {
    const { callApi } = this.props;
    if (callApi === "wall") {
      getPostComment(this.contentId).then((data) => {
        this.setState(
          {
            comments: data,
          },
          () => {
            this.countComments();
          }
        );
      });
    } else if (callApi === "articles") {
      getArticleComments(this.contentId).then((data) => {
        this.setState(
          {
            comments: data,
          },
          () => {
            this.countComments();
          }
        );
      });
    } else if (callApi === "formations") {
      getCourseComments(this.contentId).then((data) => {
        this.setState(
          {
            comments: data,
          },
          () => {
            this.countComments();
          }
        );
      });
    }
  };

  updateDimensions = () => {
    this.setState({ contentHeight: window.innerHeight });
  };

  countComments = () => {
    const { comments } = this.state;
    let responses = 0;
    comments.forEach((comment) => {
      responses += comment.responses.length;
    });
    this.setState({
      countRepliedComments: responses,
    });
  };

  _handleChange = (input) => (e) => {
    const value = e.target.value;

    this.setState({
      [input]: value,
    });
  };

  _handleChangeComment = (ref) => (e) => {
    this.setState(
      {
        comment: e.target.value,
      },
      () => {
        this.refs[ref].style.height = "";
        const scrollHeight = this.refs[ref].scrollHeight;
        this.refs[ref].style.height = scrollHeight + "px";
      }
    );
  };

  addComment = (e) => {
    const { comment } = this.state;
    const { callApi } = this.props;
    const trimmedComment = comment?.trim();
    let obj = {};
    obj.content = trimmedComment;
    obj.visible = 1;

    e.preventDefault();
    if (trimmedComment) {
      this.refs["comment_form"].reset();
      if (callApi === "wall") {
        addComment(this.contentId, obj).then(() => {
          this.getAllComments();
          this.openComments();
        });
      } else if (callApi === "articles") {
        addArticleComment(this.contentId, obj).then(() => {
          this.getAllComments();
          this.openComments();
        });
      } else if (callApi === "formations") {
        addCourseComment(this.contentId, obj).then(() => {
          this.getAllComments();
          this.openComments();
        });
      }
    }

    this.setState({
      comment: "",
    });
  };

  reply = (e) => {
    this.setState(
      {
        reply: true,
        comment_id: e.target.getAttribute("data-id"),
      },
      () => {
        this.refs["reply_comment"].focus();
      }
    );
  };

  replyComment = (e) => {
    const { comment, comment_id } = this.state;
    const { callApi } = this.props;
    const trimmedComment = comment?.trim();
    let obj = {};
    obj.content = trimmedComment;
    obj.visible = 1;

    e.preventDefault();
    if (trimmedComment) {
      this.refs["reply_comment_form"].reset();
      if (callApi === "wall") {
        replyComment(this.contentId, comment_id, obj).then(() => {
          this.getAllComments();
          this.setState(
            {
              reply: false,
            },
            () => {
              const commentContainer = this.refs["comment_container"];
              const comment = this.refs["comment_" + comment_id];
              commentContainer.scrollTo(0, comment.offsetTop - 10);
            }
          );
        });
      } else if (callApi === "articles") {
        replyArticleComment(this.contentId, comment_id, obj).then(() => {
          this.getAllComments();
          this.setState(
            {
              reply: false,
            },
            () => {
              const commentContainer = this.refs["comment_container"];
              const comment = this.refs["comment_" + comment_id];
              commentContainer.scrollTo(0, comment.offsetTop - 10);
            }
          );
        });
      } else if (callApi === "formations") {
        replyCourseComment(this.contentId, comment_id, obj).then(() => {
          this.getAllComments();
          this.setState(
            {
              reply: false,
            },
            () => {
              const commentContainer = this.refs["comment_container"];
              const comment = this.refs["comment_" + comment_id];
              commentContainer.scrollTo(0, comment.offsetTop - 10);
            }
          );
        });
      }
    }

    this.setState({
      comment: "",
    });
  };

  onFocus = (e) => {
    this.setState({ focus: true });
  };

  onBlur = () => {
    this.setState({
      focus: false,
      reply: false,
    });
  };

  openComments = () => {
    this.getAllComments();
    this.setState({
      showComments: true,
    });
    window.scroll(0, 0);
    document.body.style.overflow = "hidden";
  };

  closeComments = () => {
    this.setState({
      showComments: false,
      reply: false,
    });
    document.body.style.overflow = "auto";
  };

  render() {
    const { currentUserAvatar, isWall, legend, user, userPostPicture, t } =
      this.props;
    const {
      contentHeight,
      comments,
      countRepliedComments,
      focus,
      reply,
      showComments,
    } = this.state;

    const totalCommentsCount = comments.length + countRepliedComments;

    return (
      <div className="comments_container">
        <div className="show_comment">
          <div className="comments_count">
            {comments.length > 0 ? (
              totalCommentsCount === 1 ? (
                <div onClick={this.openComments}>
                  <Trans
                    i18nKey="show_comment"
                    count={totalCommentsCount}
                    defaults="See the <1>{{count}}</1> comment"
                    components={{1: <span />}}
                  />
                </div>
              ) : (
                <div onClick={this.openComments}>
                  <Trans
                    i18nKey="show_comments"
                    count={totalCommentsCount}
                    defaults="See the <1>{{count}}</1> comments"
                    components={{1: <span />}}
                  />
                </div>
              )
            ) : (
              t("no_comments")
            )}
          </div>
        </div>
        <div className="add_comment">
          <div className="avatar">
            {currentUserAvatar ? (
              <Image src={currentUserAvatar} alt="" />
            ) : (
              <img src={images.icon_user} alt="" />
            )}
          </div>
          <form
            className={focus ? "focus" : null}
            ref="comment_form"
            onSubmit={this.addComment.bind(this)}
          >
            <textarea
              id="add_comment"
              ref="add_comment"
              onFocus={this.onFocus}
              onChange={this._handleChangeComment("add_comment")}
              placeholder={t("add_comment")}
            />
            {focus && (
              <button type="submit" className="publish_comment">
                {t("submit")}
              </button>
            )}
          </form>
        </div>

        {/* MODAL COMMENTAIRES */}
        {showComments && (
          <div className="show_comments-container">
            <div
              className={
                isWall
                  ? "show_comments-header wall"
                  : "show_comments-header article"
              }
            >
              <div className="back_link" onClick={this.closeComments}></div>
              <span>{t("comments")}</span>
            </div>
            <div
              className="all_comments"
              ref="comment_container"
              style={{
                height: isWall ? contentHeight - 100 : contentHeight - 40,
              }}
            >
              {isWall && (
                <div className="post">
                  <div className="user_avatar">
                    {userPostPicture ? (
                      <Image src={userPostPicture} alt="avatar" />
                    ) : (
                      <img src={images.icon_user} alt="avatar" />
                    )}
                  </div>
                  <div className="user_comment">
                    <span className="username">{user}</span>
                    {legend !== "undefined" && <span>{legend}</span>}
                  </div>
                </div>
              )}
              {/* AFFICHE TOUS LES COMMENTAIRES */}
              {comments.map((comment, index) => (
                <div className="comment_wrapper" key={index}>
                  <div className="comment" ref={"comment_" + comment.id}>
                    <div className="user_avatar">
                      {comment.user_picture ? (
                        <Image src={comment.user_picture} alt="avatar" />
                      ) : (
                        <img src={images.icon_user} alt="avatar" />
                      )}
                    </div>
                    <div className="user_comment">
                      <span className="username">{comment.user}</span>
                      {comment.content}
                    </div>

                    {/* AFFICHE LES REPONSES S'IL Y EN A */}
                    {comment.responses && (
                      <div className="responses_container">
                        {comment.responses.map((response, index) => (
                          <div className="response" key={index}>
                            <div className="user_avatar response_user_avatar">
                              {response.user_picture ? (
                                <Image
                                  src={response.user_picture}
                                  alt="avatar"
                                />
                              ) : (
                                <img src={images.icon_user} alt="avatar" />
                              )}
                            </div>
                            <div className="response_comment">
                              <span className="username">{response.user}</span>
                              {response.content}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div
                    className="comment_options"
                    data-id={comment.id}
                    onClick={this.reply.bind(this)}
                  >
                    {t("reply")}
                  </div>
                </div>
              ))}

              {/* INPUTE REPONSE COMMENTAIRE */}
              {reply && (
                <div className="add_comment reply">
                  <div className="avatar">
                    {currentUserAvatar ? (
                      <Image src={currentUserAvatar} alt="" />
                    ) : (
                      <img src={images.icon_user} alt="" />
                    )}
                  </div>
                  <form
                    className={focus ? "focus" : null}
                    ref="reply_comment_form"
                    onSubmit={this.replyComment.bind(this)}
                  >
                    <textarea
                      id="reply_comment"
                      ref="reply_comment"
                      onFocus={this.onFocus}
                      onChange={this._handleChangeComment("reply_comment")}
                      placeholder={t("add_comment")}
                    />
                    {focus && (
                      <button type="submit" className="publish_comment">
                        {t("submit")}
                      </button>
                    )}
                  </form>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(InsComments);
